import React from "react";
import { useTranslation } from "react-i18next";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Button, Typography } from "@mui/material";

interface Step10Props {
  isSimpleLoan: boolean;
  isFacility: boolean;
  editMode?: boolean;
  onClose: (refetch?: boolean) => void;
}

export const Step10Done: React.FC<Step10Props> = ({ isSimpleLoan, isFacility, editMode = false, onClose }) => {
  const { t } = useTranslation("debt");

  return (
    <Box sx={{ textAlign: "center", py: 6 }}>
      <CheckCircleIcon sx={{ fontSize: 72, color: "success.main", mb: 3 }} />
      <Typography variant="h5" fontWeight={700} gutterBottom>
        {editMode
          ? t("wizard.done.changesSaved")
          : isSimpleLoan
            ? t("wizard.done.loanCreated")
            : t("wizard.done.facilityCreated")}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 5, maxWidth: 400, mx: "auto" }}>
        {editMode
          ? t("wizard.done.changesDesc")
          : isFacility
            ? t("wizard.done.facilityDesc")
            : t("wizard.done.loanDesc")}
      </Typography>
      <Button variant="contained" onClick={() => onClose(true)}>
        {editMode ? t("wizard.done.doneButton") : t("wizard.done.goToFacility")}
      </Button>
    </Box>
  );
};
